import {useQuery} from '@tanstack/react-query'

import {STALE} from '#/state/queries'
import {useSession} from '#/state/session'

const INVITE_WORKER_URL = 'https://batesky-invite-system.attps.workers.dev'

const RQKEY_ROOT = 'batesky-members'
export const RQKEY = [RQKEY_ROOT]

export function useBateskyMembersQuery() {
  const {currentAccount} = useSession()

  return useQuery<Array<{did: string; username: string}>>({
    staleTime: STALE.MINUTES.FIVE,
    queryKey: RQKEY,
    async queryFn() {
      const res = await fetch(`${INVITE_WORKER_URL}/list-users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!res.ok) {
        throw new Error('Failed to fetch Batesky members')
      }

      const data = (await res.json()) as {
        users: Array<{did: string; username: string}>
      }
      return data.users.filter(u => u.did !== currentAccount?.did)
    },
    enabled: !!currentAccount,
  })
}
